<template>
    <div>
        <div class="splide" id="main-slider"  v-if="campaignImage.length > 1">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide main-slider" v-for="(image, k) in campaignImage" :key="'main_' + k">
                        <div class="detail-img">
                            <img @click="clcikImg()" :src="image.fullImageUrl" />
                            <div v-if="campaign.qty == 0">
                                <div class="bg-campaign-sold-out"></div>
                                <div class="campaign-sold-out">
                                    <div class="sold-out">
                                        <div class="text-sold-out">Sold out</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div v-else>
            <div class="detail-img">
                <img :src="campaignImage[0].fullImageUrl" />
                <div v-if="campaign.qty == 0">
                    <div class="bg-campaign-sold-out"></div>
                    <div class="campaign-sold-out">
                        <div class="sold-out">
                            <div class="text-sold-out">Sold out</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="splide mt-4" id="thumbnail-slider">
             <div class="splide__track slider-width">
                   <ul class="splide__list">
                        <li class="splide__slide" v-for="(image, k) in campaignImage" :key="k">
                            <div class="container">
                                <div class="thumbnail-img">
                                    <img :src="image.fullImageUrl" />
                                </div>
                            </div>
                        </li>
                    </ul>
            </div>
            <div class="splide__arrows">
                <button class="splide__arrow splide__arrow--prev">
                    <img src="../../../../assets/new/icon/Arrow-Prev.svg"/>
                </button>
                <button class="splide__arrow splide__arrow--next">
                    <img src="../../../../assets/new/icon/Arrow-Next.svg"/>
                </button>
            </div>
        </div>
    <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
// import Carousel from "vue-owl-carousel";
import Splide from '@splidejs/splide'; //https://splidejs.com/
import ModalMixin from '@/mixin/ModalMixin';
export default {
    name: "Picture",
    mixins: [ModalMixin],
    components: {
        // Carousel
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        imgCls: String,
        campaignImage: Array,
        campaign: Object,
    },
    data: function() {
        return {
            imgCampaignClass: '',
            main: null,
            thumbnails: null,
        };
    },
    mounted: function() {
        this.initSlider();
        this.initModal();
    },
    created: function () {
    },
    methods: {
        initSlider: function() {
            if (this.campaignImage.length > 1) {
                this.setSlider()
            }
        },
        initModal: function() {
            this.initialPictureModal();
        },
        setSlider: function() {
            this.$nextTick(() => {
                this.main = new Splide('#main-slider', {
                    type: 'fade',
                    heightRatio: 1,
                    pagination: false,
                    arrows: false,
                    cover: true,
                    autoWidth:true,
                    // fixedWidth: 400,
                    // fixedHeight: 400,
                });
                this.thumbnails = new Splide('#thumbnail-slider', {
                    rewind: true,
                    fixedWidth: 40,
                    fixedHeight: 40,
                    autoWidth:true,
                    isNavigation: true,
                    gap: 10,
                    focus: 'center',
                    pagination: false,
                    cover: true,
                    breakpoints: {
                        640: {
                            autoWidth:true,
                        },
                    },
                    classes: {
                        arrow : 'splide__arrow arrows-icon-style',
                        prev  : 'splide__arrow--prev prev-icon-style',
                        next  : 'splide__arrow--next next-icon-style',
                    },
                });
                this.main.sync(this.thumbnails);
                this.main.mount();
                this.thumbnails.mount();
            })
        },
        clcikImg: function() {
            this.pictureModal
                .setCampaign(this.campaign)
                .show()
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseImage.scss";
.thumbnail-slider{
    width: 100%;
}
.container {
    width: 33px;
    padding-top: 100%;
    position: relative;
}
.thumbnail-img {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    img{
        width: 100%;
        height: 100%;
        border-radius: 5px;
    }
}
.detail-img {
    @include baseRatioImg(100%);
    position: relative;
    img {
        width: 100%;
        border-radius: 8px;
    }
    .campaign-sold-out {
        position: absolute;
        z-index: 10;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        .sold-out {
            z-index: 20;
            margin: auto;
            .text-sold-out {
                background-color: #fff;
                padding: 0 12px;
                border-radius: 50px;
            }
        }
    }
    .bg-campaign-sold-out {
        position: absolute;
        z-index: 0;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        border-radius: 8px 8px 0 0;
        opacity: 0.5;
        background-color: #333;
    }
}

#main-slider {
    .splide__slide.is-active {
        border-radius: 8px;
    }
}

#thumbnail-slider {
    .splide__track{
        margin: 0 44px;
    }
    .splide__track ul li {
        max-height: 35px;
    }
    .splide__slide.is-active {
        border: 1px solid $a-orange-f8a51b;
        border-radius: 5px;
        margin: 0 0;
        ul{
            li {
                margin-right: 16px;
                max-height: 35px;
            }
        }
    }
}

.splide__arrows {
    .splide__arrow {
        background: none;
        border: none;
        width: 40px;
        opacity: 1;
    }
    .splide__arrow--prev {
        left: 0;
    }
    .splide__arrow--next {
        right: 0;
    }
}
</style>

